<!-- menuThree  对应 二级导航的样式3  -->
<template>
  <div class="custom-submenu" :style="style"  ref="customSubMenu">
    <div class="detail"  v-if="menuData.iconUrl || menuData.alias">
      <div class="detail-icon" v-if="menuData.iconUrl">
        <img :src="menuData.iconUrl" alt="">
      </div>
      <div class="detail-desc" v-if="menuData.alias">{{ menuData.alias }}</div>
    </div>
    <div class="sub-menus" v-if="menuData.children" :style="subMenuStyle">
      <div v-for="(menu, index) in menuData.children" :key="menu.publicId" :class="activeIndex === [menuIndex, index].join('_') ? 'sub-menu-item is-active' : 'sub-menu-item'" @click="handleSubMenuSelect([menuIndex, index])">
        <span v-if="getIconPosition === 'right'"  class="title-content">{{ menu.label }}</span>
        <cxIcon class="icon" v-if="iconSet.iconType === 'icon' && iconSet.showIcon !== false" :options="titleIcon" :iconStyle="titleIconStyle"></cxIcon>
        <img class="icon" v-else-if="iconSet.iconType === 'img' && iconSet.iconSrc && iconSet.showIcon !== false" :src="iconSet.iconSrc" :style="titleIconStyle"/>
        <span v-if="getIconPosition === 'left'"  class="title-content">{{ menu.label }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { isPlainObject, customUnitTranform, isSsrPage, remCheck } from '@/utils/index'
import defaultProps, { propTypeMap, unitMap } from './defaultProps.js'
import propTrans from './../setting/propTrans.js'
import $ from 'jquery'
export default {
  props: {
    menuIndex: Number,
    menuData: {
      type: Object,
      default: () => ({
        alias: '',
        iconUrl: '',
        label: '',
        children: []
      })
    },
    config: {
      type: Object,
      default: () => Object.create(null)
    }
  },
  data() {
    return {
      leftPos: 0,
      defaultProps: JSON.parse(JSON.stringify(defaultProps)),
      activeIndex: ""
    }
  },
  watch: {
    navSizeWidth(n) {
      if (n) {
        this.$nextTick(() => {
          this.checkLeftPosition()
        })
      }
    },
    alignType() {
      this.$nextTick(() => {
        this.checkLeftPosition(false,true)
      })
    },
    pageWidth(newVal) {
      this.$nextTick(() => {
        newVal && this.checkLeftPosition()
      })
    },
    'finalConfig.connectorSet.showConnector': function() {
      this.$nextTick(() => {
        this.checkLeftPosition(true)
      })
    },
  },
  computed: {
    navSizeWidth() {
      return this.finalConfig?.navSize?.width
    },
    pageWidth() {
      return remCheck(this.$store.state[this.request_prefix].page.pageWidth) ?? "1920px"
    },
    zoomActual() {
      return this.$store.state.states.zoomActual
    },
    subMenuStyle() {
      // 如果是自适应，还是用行数 * 行宽的模式
      if (this.style?.['--navSize_width'] === 'auto') {
        return {
          gridTemplateColumns: `repeat(${this.style["--cols"]}, ${this.style["--colWidth"]})`
        }
      }
    },
    alignType() {
      return this.finalConfig?.navSite?.alignmentType
    },
    finalConfig() {
      const config = {...this.defaultProps}
      Object.entries(this.config).forEach(([key, value]) => {
        if (isPlainObject(value) && isPlainObject(config[key])) {
          config[key] = {...config[key], ...value}
        } else if ([Boolean, String, Number].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        } else {
          config[key] = this.config[key] ?? config[key]
        }
      })
      Object.entries(config).forEach(([key, value]) => {
        if (['number', 'string'].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        }
        if (propTrans[propTypeMap[key]]) {
          config[key] = propTrans[propTypeMap[key]](value)
        }
      })
      return config
    },
    style() {
      const styleObject = {}
      Object.entries(this.finalConfig).forEach(([key, value]) => {
        if (isPlainObject(value)) {
          Object.entries(value).forEach(([subKey, value]) => {
            styleObject[`--${key}_${subKey}`] = customUnitTranform(subKey, value)
          })
        } else {
          styleObject[`--${key}`] = customUnitTranform(key, value)
        }
      })
      return styleObject
    },
    getIconPosition() {
      return this.iconSet?.iconPosition
    },
    iconSet() {
      return this.finalConfig?.secondNavIcon
    },
    titleIcon() {
      return {
        iconSrc: this.iconSet.iconSrc,
        iconWidth: this.iconSet.iconWidth,
        iconMargin: this.iconSet.iconMargin,
        iconPosition: this.iconSet.iconPosition
      }
    },
    titleIconStyle() {
      const data = this.iconSet
      return {
        "display": "inline-block",
        "vertical-align": "middle",
        '--color': data.iconColor,
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
            ? `0 ${remCheck(data.iconMargin)} 0 0`
            : `0 0 0 ${remCheck(data.iconMargin)}`
      }
    },
  },
  methods: {
    getZoom(colContainer) {
      if (this.isFirstFullScroll) {
        return parseFloat(getComputedStyle($(colContainer).parents('.page-layout-wrapper')[0])?.zoom)
      } else if (this.pageEnableFullScroll) {
        return parseFloat(getComputedStyle(colContainer)?.zoom)
      } else return parseFloat(getComputedStyle($(colContainer).parents('.page-layout-wrapper')[0])?.zoom)
    },
    handleSubMenuSelect(pathArr) {
      this.activeIndex = pathArr.join('_')
      this.$emit('subMenuSelect', pathArr.join('_'))
    },
    checkLeftPosition(isChangeConnectorSet,ignoreUlTop) {
      if (!this.rootFontSize) {
        this.rootFontSize = parseFloat(document.querySelector("html").style.fontSize || '192px')
      }
      const currentSubMenu = this.$refs.customSubMenu
      const parentSubMenuDom = $(this.$refs.customSubMenu).parents(".el-submenu")?.[0]
      const colContainer = $(this.$refs.customSubMenu).parents(".layout-col__container")?.[0]
      const zoom = this.roomActuall ?? 1
      // const colContainerRect = colContainer?.getBoundingClientRect()
      // const innerWidth = window.innerWidth
      const bodyWidth = parseFloat(getComputedStyle(document.body).width)
      let translateLeft = 0
      if (parentSubMenuDom) {
        this.leftPos = parentSubMenuDom?.getBoundingClientRect()?.left
        if (this?.config?.navSize?.widthFull) {
          translateLeft = (parseFloat(this.finalConfig.ulMargin ?? 0)- this.leftPos) / zoom
          // currentSubMenu &&
          //   currentSubMenu.style.setProperty("width", (bodyWidth - 2 * parseFloat(this.finalConfig.ulMargin ?? 0)) / zoom + 'px' , "important")
            parentSubMenuDom.querySelector(".el-menu--horizontal") &&
          translateLeft !== 0 &&
            (parentSubMenuDom.querySelector(".el-menu--horizontal").style.transform = `translate(${translateLeft}px)`)
          if (parentSubMenuDom.querySelector(".el-menu--horizontal")) {
            parentSubMenuDom.querySelector(".el-menu--horizontal").style.setProperty("left", 0, "important")
            this?.config?.navSize?.widthFull && parentSubMenuDom.querySelector(".el-menu--horizontal").classList.add("full-width-submenu")
          }
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList
            .remove("sub_menu_left", "sub_menu_right", "sub_menu_center")
        } else {
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList.remove("full-width-submenu")
          parentSubMenuDom.querySelector(".el-menu--horizontal").style.setProperty("left", 'unset')
          parentSubMenuDom.querySelector(".el-menu--horizontal").style.setProperty("transform", 'none')
          parentSubMenuDom.querySelector(".el-menu--horizontal").classList
            .remove("sub_menu_left", "sub_menu_right", "sub_menu_center")
          // parentSubMenuDom.querySelector(".el-menu--horizontal").classList.add('sub_menu_' + this.finalConfig.navPopPosition)
        }
        if(ignoreUlTop){
          return
        }
        let ulTop = parseInt(getComputedStyle(parentSubMenuDom).getPropertyValue("--ulTopDefault"))
        // if(isChangeConnectorSet){
        //   ulTop = this.finalConfig.connectorSet.showConnector ? ulTop + 25+ 'px': ulTop -25 + 'px'
        // }else{
        //   ulTop = this.finalConfig.connectorSet.showConnector ? ulTop + 25+ 'px': ulTop + 'px'
        // }
        ulTop = this.finalConfig.connectorSet.showConnector ? ulTop + 25+ 'px': ulTop + 'px'
        parentSubMenuDom.style.setProperty("--ulTop", ulTop)

        // let ulTop = parseInt(getComputedStyle(parentSubMenuDom).getPropertyValue("--ulTop"))
        // if(isChangeConnectorSet){
        //   ulTop = this.finalConfig.connectorSet.showConnector ? ulTop + 25+ 'px': ulTop -25 + 'px'
        // }else{
        //   ulTop = this.finalConfig.connectorSet.showConnector ? ulTop + 25+ 'px': ulTop + 'px'
        // }
        // parentSubMenuDom.style.setProperty("--ulTop", ulTop)
      }
    }
  },
  mounted() {
    if (!isSsrPage()) {
      this.checkLeftPosition()
    }
  }
}
</script>
<style lang="scss" scoped>
.detail {
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
}
.detail-icon {
  flex-shrink: 0;
}
.detail-icon img {
  display: block;
  width: var(--coverSize_width);
  height: var(--coverSize_height);
  padding: var(--coverPadding);
  border-style: var(--coverBorder_borderStyle);
  border-width: var(--coverBorder_borderWidth);
  border-color: var(--coverBorder_borderColor) !important;
  box-shadow: var(--coverShadow);
  border-radius: var(--coverRadius);
  box-sizing: content-box;
}
.detail-desc {
  width: var(--descSize_width);
  height: var(--descSize_height);
  padding: var(--descPadding);
  font-size: var(--descFont_fontSize);
  font-weight: var(--descFont_fontWeight);
  color: var(--descFont_fontColor);
  letter-spacing: var(--descFont_letterSpacing);
  text-decoration: var(--descFont_textDecoration);
  font-style: var(--descFont_fontStyle);
  text-align: var(--descFont_textAlign);
  line-height: var(--descFont_lineHeight);
  overflow: hidden;
  box-shadow: var(--descShadow);
  border-style: var(--descBorder_borderStyle);
  border-width: var(--descBorder_borderWidth);
  border-color: var(--descBorder_borderColor) !important;
  box-sizing: content-box;
  flex-shrink: 0;
}
.custom-submenu {
  width: var(--navSize_width);
  height: var(--navSize_height);
  overflow-y: auto;
  box-sizing: content-box;
  display: flex;
  gap: 10px;
  font-family: "PingFang SC";
  padding: var(--navPadding);
  border-style: var(--navBorder_borderStyle);
  border-width: var(--navBorder_borderWidth);
  border-color: var(--navBorder_borderColor) !important;
  border-radius: var(--navBorderRadius);
  background-color: var(--wholeBackground_backgroundColor);
  background-image: var(--wholeBackground_backgroundImage);
  background-repeat: var(--wholeBackground_backgroundRepeat);
  background-position: var(--wholeBackground_backgroundPosition);
  background-size: var(--wholeBackground_backgroundSize);
  box-shadow: var(--navBoxShadow);
  position: relative;
  //justify-content: center;
  justify-content: var(--navSite_alignmentType);
}
.sub-menus {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, var(--colWidth));
  grid-auto-flow: row;
  grid-auto-rows: var(--titleFont_lineHeight);
  grid-row-gap: var(--rowGap);
  grid-column-gap: var(--colGap);
  flex-wrap: wrap;
  font-weight: 400;
  font-size: 16px;
  flex-shrink: 1
}
.sub-menu-item {
  cursor: pointer;
  padding: var(--titlePadding);
  font-size: var(--titleFont_fontSize);
  font-weight: var(--titleFont_fontWeight);
  color: var(--titleFont_fontColor);
  letter-spacing: var(--titleFont_letterSpacing);
  text-decoration: var(--titleFont_textDecoration);
  font-style: var(--titleFont_fontStyle);
  line-height: var(--titleFont_lineHeight);
  overflow: hidden;
  box-shadow: var(--titleBoxShadow);
  border-style: var(--titleBorder_borderStyle);
  border-width: var(--titleBorder_borderWidth);
  border-color: var(--titleBorder_borderColor) !important;
  border-radius: var(--titleRadius);
  font-family:  var(--titleFont_fontFamily);
  text-align: var(--titleFont_textAlign);
  &:hover {
    border-radius: var(--titleHoverRadius);
    background-color: var(--titleHoverBackground_backgroundColor);
    background-image: var(--titleHoverBackground_backgroundImage);
    background-repeat: var(--titleHoverBackground_backgroundRepeat);
    background-position: var(--titleHoverBackground_backgroundPosition);
    background-size: var(-titleHoverBackground_backgroundSize);
    font-family:  var(--titleHoverFont_fontFamily);
    font-size: var(--titleHoverFont_fontSize);
    font-weight: var(--titleHoverFont_fontWeight);
    color: var(--titleHoverFont_fontColor);
    letter-spacing: var(--titleHoverFont_letterSpacing);
    text-decoration: var(--titleHoverFont_textDecoration);
    font-style: var(--titleHoverFont_fontStyle);
    line-height: var(--titleHoverFont_lineHeight);
    text-align: var(--titleHoverFont_textAlign);
  }
  &.is-active {
    border-radius: var(--titleActiveRadius);
    background-color: var(--titleActiveBackground_backgroundColor);
    background-image: var(--titleActiveBackground_backgroundImage);
    background-repeat: var(--titleActiveBackground_backgroundRepeat);
    background-position: var(--titleActiveBackground_backgroundPosition);
    background-size: var(-titleActiveBackground_backgroundSize);
    font-family:  var(--titleActiveFont_fontFamily);
    font-size: var(--titleActiveFont_fontSize);
    font-weight: var(--titleActiveFont_fontWeight);
    color: var(--titleActiveFont_fontColor);
    letter-spacing: var(--titleActiveFont_letterSpacing);
    text-decoration: var(--titleActiveFont_textDecoration);
    font-style: var(--titleActiveFont_fontStyle);
    line-height: var(--titleActiveFont_lineHeight);
    text-align: var(--titleActiveFont_textAlign);
  }
}
</style>
